import { configureStore } from "@reduxjs/toolkit";
import langReducer from './langReducer';

const store = configureStore({
    reducer: {
        langReducer: langReducer
    }
});

export default store;